module.exports = __webpack_public_path__ + "ath_game_web/img/token_alloc.77f45816.png";